import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DataService} from '../Services/data.service';

import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isWeekend,
  isSameMonth,
  isToday,
  addHours
} from 'date-fns';

import {
  CalendarEvent,
} from 'angular-calendar';


import {NgbModal, NgbDateStruct, NgbCalendar, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs/Subject';
import {PersonLunch} from '../Model/PersonLunch';
import {StandardDays} from '../Model/StandardDays';
import {CalendarDatePipe} from 'angular-calendar/modules/common/calendar-date.pipe';
import {Router} from '@angular/router';
import {CustomDatepickerI18n, I18n} from '../DatePicker/datepicker-i18n';


const colors: any = {
  red: {
    primary: '#dc3545',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  green: {
    primary: '#28a745',
    secondary: '#92fdae'
  }
};

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;

@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.css'],
  providers: [CalendarDatePipe, I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}]
})

export class SubmitComponent implements OnInit {
  @ViewChild('modalContent') modalContent: TemplateRef<any>;

  @ViewChild('content') submitContent: TemplateRef<any>;

  @ViewChild('VacationPeriod') vacationContent: TemplateRef<any>;

  @ViewChild('ChangePassword') changePasswordContent: TemplateRef<any>;

  @Input() locale = 'en';

  model;

  personLunches: PersonLunch[];

  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  view: String = 'month';

  viewDate: Date = new Date();

  today: Date = new Date();

  refresh: Subject<any> = new Subject();

  events: MyEvent[] = [];

  activeDayIsOpen = false;

  hoveredDate: NgbDateStruct;

  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;

  newPassword;
  newPasswordRepeat;

  time: string;

  tooLate: boolean;
  alreadySubmitted: boolean;
  day: any;
  clickedDate: Date;
  standardDays: StandardDays;

  roleIdOfLoggedInPerson = 0;

  guestBoolean = false;
  snackBoolean = false;
  guestAmount;
  guestInformation;

  constructor(private dataService: DataService, private modalService: NgbModal, private router: Router, calendar: NgbCalendar) {
    const todayPlusOneDay = calendar.getToday();
    todayPlusOneDay.day = todayPlusOneDay.day + 1;
    this.fromDate = todayPlusOneDay;
    this.toDate = calendar.getNext(todayPlusOneDay, 'd', 10);
    this.checkRole();
    this.roleIdOfLoggedInPerson = this.dataService.role.id;

  }

  checkRole(): void {
    console.log(this.dataService.role);
    if (this.dataService.role.id !== 1 && this.dataService.role.id !== 2) {
      if (this.dataService.role.id === 7) {
        this.router.navigateByUrl('kantine');
      } else if (this.dataService.role.id === 6) {
        this.router.navigateByUrl('secretariaat')
      } else if (this.dataService.role.id === 4 || this.dataService.role.id === 5) {
        this.router.navigateByUrl('HRFinance')
      } else if (this.dataService.role.id === 8) {
        this.router.navigateByUrl('Telfort')
      }
    }
  }

  ngOnInit(): void {
    this.time = '00';
    this.getUserLunches();
  }

  open(content, day) {
    this.clickedDate = day.date;
    this.day = day;
    this.alreadySubmitted = day.events.length > 0;
    this.tooLate = false;

    this.dataService.checkDateAndHourValidity(this.formatDateToISO(day.date)).then((dateTimeValidationResponse) => {
      this.tooLate = !dateTimeValidationResponse.dateAndHourValid;

      if (day.events[0]) {
        this.time = day.events[0].time;
      } else {
        this.time = '00'
      }
      if (day.events.length > 0 && day.events[0].guestAmount > 0) {
        this.guestBoolean = true;
        this.guestAmount = day.events[0].guestAmount;
        this.guestInformation = day.events[0].guestInformation;
      } else {
        this.guestBoolean = false;
        this.guestAmount = 0;
        this.guestInformation = '';
      }
      if (day.events.length > 0 && day.events[0].snackBoolean === true) {
        this.snackBoolean = true;
      }

      this.modalService.open(content).result.then((result) => {
        this.subscribeOrNotSubscribe(result, day);
      }, (response) => {
        console.log(response);
      });
    });
  }

  subscribeOrNotSubscribe(result, day) {
    if (!this.guestBoolean) {
      this.guestBoolean = false;
      this.guestAmount = 0;
      this.guestInformation = '';
    }

    if (result === 'aanmelden') {
      this.subscribeToDay(day.date, true);
    } else if (result === 'afmelden') {
      this.guestBoolean = false;
      this.guestAmount = 0;
      this.guestInformation = '';
      this.subscribeToDay(day.date, false);
    }
  }

  subscribeToDay(date, goLunch) {
    this.dataService.subscribeToDay(date, goLunch, this.time, this.guestAmount, this.guestInformation, this.snackBoolean);
    if (this.alreadySubmitted) {
      for (let i = 0; i < this.events.length; i++) {
        if (new Date(this.events[i].start).getDate() === date.getDate() && new Date(this.events[i].start).getMonth() === date.getMonth()) {
          this.events.splice(i, 1);
        }
      }
    }
    const title = goLunch ? 'Signed up for lunch' : 'Signed off for lunch';
    const color = goLunch ? colors.green : colors.red;
    console.log(this.time);
    this.events.push({
      start: date,
      color: color,
      end: date,
      title: title,
      time: this.time,
      guestAmount: this.guestAmount,
      guestInformation: this.guestInformation,
      didLunch: false,
      lunch: goLunch,
      snackBoolean: this.snackBoolean
    });
    this.refresh.next();
  }

  private formatDateToISO(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  private getUserLunches() {
    this.dataService.getPersonLunches().then((personLunches) => {
      this.personLunches = personLunches;
      this.applyPersonLunches();
    });
  }

  private applyPersonLunches() {
    const that = this;
    this.personLunches.forEach(function (personLunch) {
      if (personLunch.lunch) {
        const time = personLunch.time.toString().substring(2);
        that.events.push({
          start: personLunch.date,
          color: colors.green,
          end: personLunch.date,
          title: 'Signed up for lunch',
          time: time,
          guestAmount: personLunch.guestAmount,
          guestInformation: personLunch.guestInformation,
          didLunch: personLunch.didLunch,
          lunch: personLunch.lunch,
          snackBoolean: personLunch.wantSnack
        });
      } else {
        that.events.push({
          start: personLunch.date,
          color: colors.red,
          end: personLunch.date,
          title: 'Signed off for lunch',
          time: '00',
          guestAmount: 0,
          guestInformation: '',
          didLunch: personLunch.didLunch,
          lunch: personLunch.lunch,
          snackBoolean: personLunch.wantSnack
        });
      }
    });
    this.refresh.next();
  }

  vacationPeriod(content) {
    this.modalService.open(content).result.then((result) => {
      this.applyVacationPeriod(result);
    }).catch((response) => {
      console.log(response);
    });
  };

  changePassword(content) {
    this.modalService.open(content).result.then((result) => {

      this.applyChangePassword(result);
    }).catch((response) => {
      console.log(response);
    });
  };

  applyVacationPeriod(result) {
    if (result === 'Indienen') {
      const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
      let toDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
      if (this.toDate != null) {
        toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
      }
      const that = this;
      this.dataService.vacationPeriod(fromDate, toDate).then(function (response) {
        console.log(response);
        that.addVacationToCalendar(fromDate, toDate);
      });
    }
  }

  applyChangePassword(result) {
    if (result === 'Indienen') {
      if (this.newPassword === this.newPasswordRepeat) {
        console.log(this.newPassword);
        console.log(this.newPasswordRepeat);
        this.dataService.changePassword(this.newPassword).then(function (response) {
          console.log(response);
        });
      }
    }
  }

  addVacationToCalendar(fromDate: Date, toDate: Date) {
    this.events.push({
      start: fromDate,
      color: colors.red,
      end: fromDate,
      time: '',
      title: 'Afgemeld lunch',
      guestAmount: 0,
      guestInformation: '',
      didLunch: false,
      lunch: false,
      snackBoolean: false
    });
    if (fromDate.toDateString() === toDate.toDateString()) {
      this.refresh.next();
      return;
    }
    const newDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    newDate.setDate(newDate.getDate() + 1);
    this.addVacationToCalendar(newDate, toDate);
  }

  onDateSelection(date: NgbDateStruct) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  setPassword(newPassword, newPasswordRepeat) {
    this.newPassword = newPassword;
    this.newPasswordRepeat = newPasswordRepeat;
  }

  guestAmountOnBlur() {
    if (this.guestAmount < 0) {
      this.guestAmount = 0;
    }
    console.log(this.guestAmount);
  }

  isHovered = date => this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate);
  isInside = date => after(date, this.fromDate) && before(date, this.toDate);
  isFrom = date => equals(date, this.fromDate);
  isTo = date => equals(date, this.toDate);

  isLaterThanOneWeekFromNow(date: Date) {
    // tslint:disable-next-line:prefer-const
    const difference_In_Time = date.getTime() - this.today.getTime();
// To calculate the no. of days between two dates
    const difference_In_Days = difference_In_Time / (1000 * 3600 * 24);

    return difference_In_Days >= 21;
  }
}


interface MyEvent extends CalendarEvent {
  time: string;
  guestAmount: number;
  guestInformation: string;
  didLunch: boolean;
  lunch: boolean;
  snackBoolean: boolean;
}



// WEBPACK FOOTER //
// ./src/app/submit/submit.component.ts